module.exports = __webpack_public_path__ + "img/donkey-emc2.81dabd3e.gif";